module.exports = __webpack_public_path__ + "static/media/image5.07e70b2d.png";